import { VoiceControlsList, VoiceControlsStatusMessage } from ".";
import {
  getSelectedDeviceData,
  refreshDeviceStatus,
} from "../../redux/voiceControl-slice";
import { useDispatch, useSelector } from "react-redux";
import cn from "classnames";
import styles from "./VoiceControlsContainer.module.scss";
import { useEffect } from "react";

export function VoiceControlsContainer({ className }) {
  const dispatch = useDispatch();
  const deviceSelected = useSelector(getSelectedDeviceData);

  useEffect(() => {
    if (deviceSelected.status === "") {
      dispatch(refreshDeviceStatus(deviceSelected.cloudId));
    }
  }, [deviceSelected, dispatch]);
  return (
    <div className={cn(styles.voiceControlsContainer, className)}>
      {deviceSelected.status === "ok" ? (
        <VoiceControlsList />
      ) : (
        <VoiceControlsStatusMessage />
      )}
    </div>
  );
}
